import { blogCmsClient } from 'src/lib/contentful-client';
import { getBlogRegionQuery } from 'src/lib/blog-regions';
import { ContentfulTemplates, Locales, type TLocale } from 'src/lib/constants';

const MIN_POSTS_PER_TAG = 4;

export const fetchTagsWithMinPosts = async (
  locale: TLocale = Locales.EN_US,
): Promise<string[]> => {
  const res = await blogCmsClient.getEntries({
    // eslint-disable-next-line @typescript-eslint/naming-convention
    content_type: ContentfulTemplates.BLOG_POST,
    ...getBlogRegionQuery(locale),
    select: ['fields.tags', 'fields.published'],
    include: 1,
    limit: 1000,
    order: ['-fields.published'],
  });

  const tagCounts: Record<string, number> = {};
  const tagLatest: Record<string, string> = {};

  res.items.forEach(
    (post: {
      fields?: { published?: string; tags?: { fields?: { tag?: string } }[] };
    }) => {
      const published: string = post.fields?.published || '';
      (post.fields?.tags || []).forEach(
        (tag: { fields?: { tag?: string } }) => {
          const tagStr = tag.fields?.tag;
          if (tagStr) {
            tagCounts[tagStr] = (tagCounts[tagStr] || 0) + 1;
            if (!tagLatest[tagStr] || published > tagLatest[tagStr]) {
              tagLatest[tagStr] = published;
            }
          }
        },
      );
    },
  );

  return Object.entries(tagCounts)
    .filter(([, count]) => {
      return count >= MIN_POSTS_PER_TAG;
    })
    .sort(([tagA], [tagB]) => {
      return (tagLatest[tagB] || '').localeCompare(tagLatest[tagA] || '');
    })
    .map(([tag]) => {
      return tag;
    });
};
